import { createFileRoute, redirect } from "@tanstack/react-router";

// Redirects rather than 404s: this was the home page's draft address, and links to it were shared.
export const Route = createFileRoute("/v2/why")({
  beforeLoad: () => {
    throw redirect({ to: "/v2", replace: true });
  },
});
